import { __decorate } from "tslib";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Datepicker from "vuejs-datepicker";
// @ts-ignore
import ReportCollection from "@/classes/ReportCollection";
let CustomerHours = class CustomerHours extends Vue {
    loadAdminTimeReports() {
        this.$data.loading = true;
        this.$store
            .dispatch("loadAdminTimeReportsAsync", {
            date: this.$store.getters.getSelectedDate,
        })
            .then((result) => {
            this.$data.reports = new ReportCollection();
            this.$data.reports.importReportObjectsFromJson(result.data);
            this.calculateTotal(); //calculate the total hours
            this.$data.loading = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "UserHours.vue -> loadAdminEmployees -> loadAdminTimeReportsAsync");
            this.$data.loading = false;
        });
    }
    //loads the employees as an admin
    loadUsers() {
        this.$store
            .dispatch("getAllUsers")
            .then((result) => {
            // this.$store.commit("setGlobalEmployeesAdmin", result.data);
            this.$data.users = result.data;
            //once we have the users we load the reports (we need the users to be able to calculate the total)
            this.$store
                .dispatch("loadAdminTimeReportsAsync", {
                date: this.$store.getters.getSelectedDate,
            })
                .then((result2) => {
                this.$data.reports = new ReportCollection();
                this.$data.reports.importReportObjectsFromJson(result2.data);
                this.calculateTotal(); //calculate the total hours
                this.$data.preloaded = true;
            })
                .catch((err) => {
                this.$data.preloaded = true;
                window.errorHandler.logError(err, "UserHours.vue -> loadAdminEmployees -> loadAdminTimeReportsAsync");
            });
        })
            .catch((err) => {
            this.$data.preloaded = true;
            window.errorHandler.logError(err, "UserHours.vue - loadAdminEmployees");
        });
    }
    // function that loads the holidays data object from the store. Loads locally if available API otherwise.
    loadHolidayData() {
        this.$data.holidays = this.$store.getters.getHolidays;
        if (this.$store.getters.getHolidays === null) {
            const currentYear = moment(this.$store.getters.getSelectedDate).format("YYYY");
            this.$store
                .dispatch("loadHolidaysAsync", { year: currentYear })
                .then((holidays) => {
                this.$store.commit("setHolidays", {
                    data: holidays.data,
                    year: currentYear,
                });
                this.$data.holidays = holidays.data;
            })
                .catch((err) => {
                window.errorHandler.logError(err, "CustomerHours.vue - loadHolidayData");
            });
        }
    }
    convertToCurrency(value) {
        return Number(value).toLocaleString("se");
    }
    calculateAvailableHours() {
        const start = window.dateHandler
            .getStartOfMonth(this.$store.getters.getSelectedDate)
            .format("YYYY-MM-DD");
        let totalHours = 0;
        for (let i = 0; i < moment(start).daysInMonth(); i++) {
            const date = window.dateHandler.addDays(start, i);
            if (this.isNonWorkingDay(date) === false) {
                totalHours += 8;
            }
        }
        return totalHours;
    }
    isNonWorkingDay(date) {
        const holidayColl = this.$data.holidays;
        let holiday;
        if (holidayColl !== undefined && holidayColl !== null) {
            holiday = holidayColl.getHolidayForDate(date);
        }
        if (holiday !== undefined) {
            return true;
        }
        else if (moment(date).isoWeekday() === 6 ||
            moment(date).isoWeekday() === 7) {
            return true;
        }
        else {
            return false;
        }
    }
    calculateTotal() {
        const summary = [];
        let allBillable = 0;
        let allHours = 0;
        const allProjected = 0;
        const customers = this.getCustomerNames();
        customers.forEach((customerName) => {
            let allBillableCustomer = 0;
            let allHoursCustomer = 0;
            let customerReports = this.generate(customerName);
            if (this.$data.filter !== "") {
                customerReports = this.generate(customerName).filter((report) => {
                    for (const prop in report) {
                        if (Object.prototype.hasOwnProperty.call(report, prop)) {
                            const propVal = "" + report[prop];
                            if (propVal
                                .toString()
                                .toLowerCase()
                                .indexOf(this.$data.filter.toLowerCase().trim()) !== -1) {
                                return true;
                            }
                        }
                    }
                });
            }
            customerReports.forEach((report) => {
                allHours += report.totalHours;
                allHoursCustomer += report.totalHours;
                if (report.billable === true) {
                    allBillable += report.totalHours;
                    allBillableCustomer += report.totalHours;
                }
            });
            summary[customerName] = {
                tHours: allHoursCustomer,
                tBillable: allBillableCustomer,
            };
        });
        //@ts-ignore
        summary["total"] = {
            tHours: allHours,
            tBillable: allBillable,
        };
        this.$data.totalHours = summary;
    }
    getCustomerNames() {
        const customerNames = [
            ...new Set(this.$data.reports.reports.map((x) => x.customerName)),
        ];
        return customerNames;
    }
    getReportsForCustomer(customerName) {
        const customerReports = this.$data.reports.reports.filter((report) => {
            return report.customerName === customerName;
        });
        return customerReports;
    }
    getTariffIdsForCustomer(customerName) {
        const customerReports = this.getReportsForCustomer(customerName);
        const tariffs = [
            ...new Set(customerReports.map((x) => x.tariffId)),
        ];
        return tariffs;
    }
    getUserIdsForTariff(tariffId) {
        const tariffReports = this.$data.reports.reports.filter((report) => {
            return report.tariffId === tariffId;
        });
        const users = [...new Set(tariffReports.map((x) => x.userId))];
        return users.sort((a, b) => (a < b ? -1 : 1));
    }
    getReportsForUserTariffCustomer(customerName, tariffId, userId) {
        const reports = this.$data.reports.reports.filter((report) => {
            return (report.tariffId === tariffId &&
                report.customerName === customerName &&
                report.userId === userId);
        });
        return reports;
    }
    getDateInfo() {
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
    getUser(userId) {
        return this.$data.users.find((user) => user.id === userId);
    }
    getName(userId) {
        const user = this.$data.users.find((user) => user.id === userId);
        if (!user)
            return "";
        return `${user.firstName} ${user.lastName}`;
    }
    generate(customerName) {
        const denseArray = [];
        const tariffIds = this.getTariffIdsForCustomer(customerName);
        tariffIds.forEach((tariffId) => {
            const userIds = this.getUserIdsForTariff(tariffId);
            userIds.forEach((userId) => {
                const reports = this.getReportsForUserTariffCustomer(customerName, tariffId, userId);
                let totalHours = 0;
                reports.forEach((report) => {
                    totalHours += report.hours;
                });
                const returnObject = reports[0];
                returnObject.totalHours = totalHours;
                const userObject = this.getUser(userId);
                returnObject.userName = `${userObject.firstName} ${userObject.lastName}`;
                denseArray.push(returnObject);
            });
        });
        return denseArray;
    }
    selectPreviousMonth() {
        const newDate = window.dateHandler
            .subtractMonths(this.$store.getters.getSelectedDate, 1)
            .startOf("month")
            .format("YYYY-MM-DD");
        this.$store.commit("setSelectedDate", { date: newDate });
        this.loadAdminTimeReports();
        this.getDateInfo();
    }
    selectNextMonth() {
        const newDate = window.dateHandler
            .addMonths(this.$store.getters.getSelectedDate, 1)
            .startOf("month")
            .format("YYYY-MM-DD");
        this.$store.commit("setSelectedDate", { date: newDate });
        this.loadAdminTimeReports();
        this.getDateInfo();
    }
};
CustomerHours = __decorate([
    Component({
        data() {
            return {
                customerItems: [],
                theme: this.$store.getters.getTheme,
                userHeadings: [
                    { text: "User", value: "userName", width: "25%", align: "center" },
                    { text: "Tariff", value: "tariffName", width: "25%", align: "start" },
                    { text: "Billable", value: "billable", width: "25%", align: "start" },
                    { text: "Hours", value: "totalHours", width: "25%", align: "start" },
                    {
                        text: "Customer",
                        value: "customerName",
                        width: "0%",
                        align: " d-none",
                    },
                ],
                totalHours: null,
                selectedDate: this.$store.getters.getSelectedDate,
                holidays: null,
                //nya
                reports: null,
                users: null,
                groupedCustomers: null,
                filter: "",
                dateInfo: {
                    year: 0,
                    month: null,
                    week: 0,
                    weekHours: 0,
                    monthHours: 0,
                },
                awaitingFilter: false,
                loading: false,
                preloaded: false,
            };
        },
        watch: {
            filter(newFilter) {
                if (!this.$data.awaitingFilter) {
                    setTimeout(() => {
                        this.calculateTotal();
                        this.$data.awaitingFilter = false;
                    }, 500); // 1 sec delay
                }
                this.$data.filter = newFilter;
                this.$data.awaitingFilter = true;
            },
        },
        created() {
            this.$store.commit("setSelectedDate", {
                date: this.$store.getters.getSelectedDate,
            });
            this.loadUsers();
            this.getDateInfo();
            this.loadHolidayData();
        },
        components: {
            Datepicker,
            IconBox,
            IconBoxContent,
            WhiteBox,
        },
    })
], CustomerHours);
export default CustomerHours;
